import Vue from "vue";
import me from "../../api/me";
import store from "@/store";

export default async function log({ next, to}) {
  const res = await me()
  if(res !== null) {
    store.commit('setUserName', res.data.name)
    store.commit('setUserRole', res.data.role)
  }
  if(res == null) Vue.$router.push('/')
  else return next();
}
